var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolarCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2954 35H23.702C28.9037 35 31.5054 35 33.3737 33.775C34.1798 33.2466 34.8741 32.5647 35.417 31.7683C36.6654 29.935 36.6654 27.38 36.6654 22.2733C36.6654 17.165 36.6654 14.6116 35.417 12.7783C34.8742 11.9818 34.1799 11.3 33.3737 10.7716C32.1737 9.98329 30.6704 9.70162 28.3687 9.60162C27.2704 9.60162 26.3254 8.78496 26.1104 7.72662C25.9461 6.9514 25.5191 6.25668 24.9018 5.75987C24.2844 5.26306 23.5145 4.99464 22.722 4.99996H17.2754C15.6287 4.99996 14.2104 6.14162 13.887 7.72662C13.672 8.78496 12.727 9.60162 11.6287 9.60162C9.3287 9.70162 7.82536 9.98495 6.6237 10.7716C5.81806 11.3001 5.12432 11.9819 4.58203 12.7783C3.33203 14.6116 3.33203 17.165 3.33203 22.2733C3.33203 27.38 3.33203 29.9333 4.58036 31.7683C5.12036 32.5616 5.8137 33.2433 6.6237 33.775C8.49203 35 11.0937 35 16.2954 35Z",
    stroke: "#296386",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0013 11.6666C16.7763 11.6666 14.168 14.275 14.168 17.5C14.168 21.875 20.0013 28.3333 20.0013 28.3333C20.0013 28.3333 25.8346 21.875 25.8346 17.5C25.8346 14.275 23.2263 11.6666 20.0013 11.6666ZM15.8346 17.5C15.8346 15.2 17.7013 13.3333 20.0013 13.3333C22.3013 13.3333 24.168 15.2 24.168 17.5C24.168 19.9 21.768 23.4916 20.0013 25.7333C18.268 23.5083 15.8346 19.875 15.8346 17.5Z",
    fill: "#296386"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0013 19.5833C21.1519 19.5833 22.0846 18.6506 22.0846 17.5C22.0846 16.3494 21.1519 15.4166 20.0013 15.4166C18.8507 15.4166 17.918 16.3494 17.918 17.5C17.918 18.6506 18.8507 19.5833 20.0013 19.5833Z",
    fill: "#296386"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarCamera);
export default __webpack_public_path__ + "static/media/solar-camera.f4731515c92445e185d36519286dbc02.svg";
export { ForwardRef as ReactComponent };